import React, { useState } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import Image from './Image';
import { getBrandGradient, isValidImageUrl } from '~src/utils/brandAvatarGenerator';

interface BrandCoverProps {
  brandName: string;
  coverImage?: string | null;
  height?: number | string;
  sx?: SxProps<Theme>;
}

/**
 * BrandCover component that displays either the brand's cover image
 * or a generated gradient background based on the brand's color
 */
export const BrandCover: React.FC<BrandCoverProps> = ({
  brandName,
  coverImage,
  height = 100,
  sx = {},
}) => {
  const [imageError, setImageError] = useState(false);
  const hasValidImage = isValidImageUrl(coverImage) && !imageError;
  
  const brandGradient = getBrandGradient(brandName);

  if (hasValidImage) {
    return (
      <Box
        sx={{
          width: '100%',
          height,
          overflow: 'hidden',
          position: 'relative',
          ...sx,
        }}
      >
        <Image
          src={coverImage!}
          alt={`${brandName} cover`}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          onError={() => setImageError(true)}
        />
      </Box>
    );
  }

  // Fallback to generated gradient
  return (
    <Box
      sx={{
        width: '100%',
        height,
        background: brandGradient,
        position: 'relative',
        ...sx,
      }}
    />
  );
};

export default BrandCover; 